import { Box, ButtonProps } from '@chakra-ui/react'
import { ThemeContext, usePopUpMessage } from '@hb/react'
import { FieldTypes, UpdateCallback } from '@hb/shared'
import React, { useCallback, useRef, useState } from 'react'
import { Form } from 'react-final-form'
import { ActionButton } from './Buttons/ActionButton'
import { Container } from './Container'
import { FormElement } from './forms'
import { InputRef } from './forms/Input/types'
import { CollapseHorizontal } from './shared'

export const AddItem: React.FC<{
  onAdd: (value: string) => Promise<UpdateCallback>
  loading?: boolean
  itemName?: string
  placeholder?: string
  buttonProps?: ButtonProps
}> = ({ onAdd, itemName = 'Item', placeholder, buttonProps }) => {
  const [active, setActive] = useState(false)
  const [addLoading, setAddLoading] = useState(false)
  const { showError } = usePopUpMessage()
  const inputRef = useRef<InputRef>(null)

  const onButtonClick = useCallback(async () => {
    setActive(true)
    inputRef.current?.focus()
  }, [inputRef])

  const onCancel = useCallback(() => {
    setActive(false)
  }, [])

  const onSubmit = useCallback(
    async ({ name }: { name: string }) => {
      setAddLoading(true)
      const res = await onAdd(name)
      if (res.error) {
        showError(res.error)
      } else {
        setActive(false)
      }
      setAddLoading(false)
      return undefined
    },
    [onAdd, showError],
  )

  return (
    <ThemeContext.Provider value={{ theme: 'basic', placeholderAbove: false }}>
      <Form onSubmit={onSubmit}>
        {({ handleSubmit, form }) => (
          <Box>
            <Container
              height="36px"
              width="auto"
              px={2}
              borderRadius={4}
              border="1px solid"
              borderColor={active ? 'gray.200' : 'transparent'}
              _dark={{ borderColor: active ? 'gray.700' : 'transparent' }}
              flexFlow="row"
              justifyContent="flex-start">
              <CollapseHorizontal enterDelay={150} width={180} in={active}>
                <Box px={2} pt={1} pb={0.5} mr={1} borderRadius={4} bg="white">
                  <FormElement
                    ref={inputRef}
                    name="name"
                    field={{
                      type: FieldTypes.TEXT,
                      placeholder: placeholder ?? `${itemName} Name`,
                      //  optional: true,
                    }}
                    inputStyle={{ paddingLeft: 0 }}
                    style={{ paddingLeft: 0 }}
                  />
                </Box>
              </CollapseHorizontal>
              <Container width="auto" alignItems="center">
                <ActionButton
                  colorScheme="gray"
                  mt={0}
                  // ml={2}
                  size="xs"
                  bg="whiteAlpha.700"
                  onClick={active ? handleSubmit : onButtonClick}
                  isLoading={addLoading}
                  {...buttonProps}>
                  {`+ Add${active ? '' : ` ${itemName}`}`}
                </ActionButton>
              </Container>
              <CollapseHorizontal
                enterDelay={150}
                opacity={active ? 1 : 0}
                width={78}
                justifyContent="center"
                alignItems="center"
                in={active}>
                <Box pl={1.5}>
                  <ActionButton
                    colorScheme="gray"
                    mt={0}
                    size="xs"
                    onClick={() => {
                      form.reset()
                      onCancel()
                    }}>
                    Cancel
                  </ActionButton>
                </Box>
              </CollapseHorizontal>
              {/* <LoadingOverlay loading={loading} /> */}
            </Container>
          </Box>
        )}
      </Form>
    </ThemeContext.Provider>
  )
}
